<template>
  <default>
    <back-nav :to="show ? 'SignIn' : ''" :pageChange="show" @click.native="onBackNavClick"/>
    <div>
      <v-container>
        <v-row no-gutters>
          <v-col lg="3" offset-lg="4" md="6" offset-md="3" sm="9" offset-sm="2" align-self="center">
            <v-card :loading="loading" class="tw-mx-2 tw-my-2" min-width="400">
              <template v-slot:loader="{ isActive }">
                <v-progress-linear :active="isActive" height="4" color="deep-purple-accent-4" indeterminate></v-progress-linear>
              </template>
              <div class="tw-w-full tw-flex tw-justify-center">
                <img src="/apalife-logo.svg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo" />
              </div>
              <v-card-title class="primary--text tw-font-bold tw-mt-2 tw-text-center"> Reset Password </v-card-title>
              <div v-if="show">
                <v-card-subtitle class="gray--text">Your password reset code will be sent to your email address.</v-card-subtitle>
                <v-card-text>
                  <div>
                    <v-form ref="form" @submit.prevent="submitForm" validate-on="submit">
                      <v-text-field id="username" label="Username/Email" prepend-icon="mdi-account" v-model="username" :rules="[required('Username/Email')]" />
                    </v-form>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn id="button" class="tw-content-center white--text" color="success" :disabled="!username" @click="sendOtp(username)"> Send OTP </v-btn>
                </v-card-actions>
              </div>
              <reset-otp v-else @resend-otp="sendOtp" @reset-pwd="resetPassword"></reset-otp>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar id="snackbar" v-model="snackbar" :color="error ? 'error' : 'success'">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </div>
  </default>
</template>
<script>
import axios from 'axios';
import Default from '../../layouts/Default.vue';
import BackNav from '../../components/BackNav.vue';
import ResetOtp from './ResetOtp.vue';
import validations from '../../utils/validations';

export default {
  name: 'ResetPassword',
  components: { Default, BackNav, ResetOtp },
  data() {
    return {
      snackbar: false,
      isValid: false,
      show: true,
      username: '',
      error: '',
      text: '',
      loading: false,
      ...validations,
    };
  },
  methods: {
    // --- New Helper Methods to resolve Sonar Duplications ---
    showSnackbarMessage(message, isError = false) {
      this.error = isError ? message : '';
      this.text = message;
      this.snackbar = true;
    },
    handleApiError(err, defaultMessage) {
      let errorMessage = defaultMessage;
      if (err.response && err.response.data) {
        errorMessage = err.response.data.msg || err.response.data.message || err.response.data || errorMessage;
      }
      this.showSnackbarMessage(errorMessage, true);
    },
    // --------------------------------------------------------
    async sendOtp(usernameInput) {
      this.username = usernameInput;
      this.loading = true;
      this.isValid = true;
      this.error = '';
      this.text = '';
      try {
        const res = await axios.post(`/lmsagent/login/initiateResetUserPassword?username=${encodeURIComponent(this.username)}`);
        if (res.data && res.data.success === true) {
          this.showSnackbarMessage('OTP sent successfully');
          this.show = false;
        } else {
          this.showSnackbarMessage(res.data?.msg || 'Failed to send OTP', true);
        }
      } catch (err) {
        this.handleApiError(err, 'Failed to send OTP. Please try again.');
      } finally {
        this.loading = false;
      }
    },
    onBackNavClick() {
      if (!this.show) {
        this.show = true;
      }
    },
    async resetPassword(form) {
      this.loading = true;
      this.error = '';
      this.text = '';
      const payload = {
        username: form?.username || form?.agentCode,
        resetCode: parseInt(form?.resetCode, 10),
        password: form?.confirmPassword,
      };
      try {
        const res = await axios.post('/lmsagent/login/resetUserPassword', payload);
        if (res.status === 200 || res.status === 201) {
          this.showSnackbarMessage('Password reset successfully');
          setTimeout(() => this.$router.push({ name: 'SignIn' }), 3000);
        } else {
          this.showSnackbarMessage(res.data?.msg || 'Password reset failed', true);
        }
      } catch (err) {
        this.handleApiError(err, 'Failed to reset password. Please try again.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<template>
  <default>
    <back-nav :to="show ? 'SignIn' : ''" :pageChange="show" @click.native="onBackNavClick"/>
    <div>
      <v-container>
        <v-row no-gutters>
          <v-col lg="3" offset-lg="4" md="6" offset-md="3" sm="9" offset-sm="2" align-self="center">
            <v-card :loading="loading" class="tw-mx-2 tw-my-2" min-width="400">
              <template v-slot:loader="{ isActive }">
                <v-progress-linear :active="isActive" height="4" color="deep-purple-accent-4" indeterminate></v-progress-linear>
              </template>
              <div class="tw-w-full tw-flex tw-justify-center">
                <img src="/apalife-logo.svg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo" />
              </div>
              <v-card-title class="primary--text tw-font-bold tw-mt-2 tw-text-center"> Reset Password </v-card-title>
              <div v-if="show">
                <v-card-subtitle class="gray--text">Your password reset code will be sent to your email address.</v-card-subtitle>
                <v-card-text>
                  <div>
                    <v-form ref="form" @submit.prevent="submitForm" validate-on="submit">
                      <v-text-field id="username" label="Username/Email" prepend-icon="mdi-account" v-model="username" :rules="[required('Username/Email')]" />
                    </v-form>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn id="button" class="tw-content-center white--text" color="success" :disabled="!username" @click="sendOtp(username)"> Send OTP </v-btn>
                </v-card-actions>
              </div>
              <reset-otp v-else @resend-otp="sendOtp" @reset-pwd="resetPassword"></reset-otp>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar id="snackbar" v-model="snackbar" :color="error ? 'error' : 'success'">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </div>
  </default>
</template>

<script>
import axios from 'axios';
import Default from '../../layouts/Default.vue';
import BackNav from '../../components/BackNav.vue';
import ResetOtp from './ResetOtp.vue';
import validations from '../../utils/validations';

export default {
  name: 'ResetPassword',
  components: { Default, BackNav, ResetOtp },
  data() {
    return {
      snackbar: false,
      isValid: false,
      show: true,
      username: '',
      error: '',
      text: '',
      loading: false,
      ...validations,
    };
  },
  methods: {
    // --- New Helper Methods to resolve Sonar Duplications ---
    showSnackbarMessage(message, isError = false) {
      this.error = isError ? message : '';
      this.text = message;
      this.snackbar = true;
    },

    handleApiError(err, defaultMessage) {
      let errorMessage = defaultMessage;
      if (err.response && err.response.data) {
        errorMessage = err.response.data.msg || err.response.data.message || err.response.data || errorMessage;
      }
      this.showSnackbarMessage(errorMessage, true);
    },
    // --------------------------------------------------------

    async sendOtp(usernameInput) {
      this.username = usernameInput;
      this.loading = true;
      this.isValid = true;
      this.error = '';
      this.text = '';
      try {
        const res = await axios.post(`/lmsagent/login/initiateResetUserPassword?username=${encodeURIComponent(this.username)}`);
        if (res.data && res.data.success === true) {
          this.showSnackbarMessage('OTP sent successfully');
          this.show = false;
        } else {
          this.showSnackbarMessage(res.data?.msg || 'Failed to send OTP', true);
        }
      } catch (err) {
        this.handleApiError(err, 'Failed to send OTP. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    onBackNavClick() {
      if (!this.show) {
        this.show = true;
      }
    },

    async resetPassword(form) {
      this.loading = true;
      this.error = '';
      this.text = '';
      const payload = {
        username: form?.username || form?.agentCode,
        resetCode: parseInt(form?.resetCode, 10),
        password: form?.confirmPassword,
      };
      try {
        const res = await axios.post('/lmsagent/login/resetUserPassword', payload);
        if (res.status === 200 || res.status === 201) {
          this.showSnackbarMessage('Password reset successfully');
          setTimeout(() => this.$router.push({ name: 'SignIn' }), 3000);
        } else {
          this.showSnackbarMessage(res.data?.msg || 'Password reset failed', true);
        }
      } catch (err) {
        this.handleApiError(err, 'Failed to reset password. Please try again.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
